import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "@src/appV2/FeatureFlags/constants";

export function useArrivalTimeConfig() {
  return useCbhFlag(CbhFeatureFlag.ARRIVAL_TIME_CONFIGURATION, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.ARRIVAL_TIME_CONFIGURATION],
  });
}
